import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Subscribe.css';

const SubscribeSuccess: React.FC = () => {
  useEffect(() => {
    document.title = 'Welcome to Pro — FitMind AI';
  }, []);

  return (
    <div className="subscribe-page">
      <header className="subscribe-header">
        <Link to="/" className="subscribe-logo">
          <img src="/logo.png" alt="FitMind AI" />
        </Link>
      </header>

      <main className="subscribe-main">
        <div className="subscribe-card">
          <div className="subscribe-icon subscribe-icon--success">
            <span>✓</span>
          </div>
          <h1>You're now Pro!</h1>
          <p>
            Your subscription is active. Open the FitMind AI app — your premium
            features are ready to use.
          </p>
          <a className="subscribe-btn subscribe-btn--primary" href="fitmindai://paywall">
            Open FitMind AI
          </a>
          <Link to="/" className="subscribe-btn subscribe-btn--outline">
            Back to website
          </Link>
        </div>
      </main>

      <footer className="subscribe-footer">
        <div className="container">
          <Link to="/">FitMind AI</Link>
          <span>·</span>
          <Link to="/privacy">Privacy Policy</Link>
          <span>·</span>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </footer>
    </div>
  );
};

export default SubscribeSuccess;
